export default "__VITE_ASSET__TEIme6Vh__"